import { useTranslation } from "react-i18next";
import i18n from "i18next";

export default () => {
  const { t } = useTranslation();

  return { t, i18n };
};
